import { setEvents, setAnalytics } from './store';

export default fetchers => store => {
    const dispatcher = store.dispatch;
    return {
        fetchers,
        requestEvents: () => fetchers.fetchEvents().then(res => setEvents(dispatcher)(res)),
        requestAnalytics: () => fetchers.fetchAnalytics().then(res => setAnalytics(dispatcher)(res))
    }
}